export const emailPattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/);
export const passwordPattern = new RegExp(/^(?=.*?)(?=.*?[0-9])(?=.*?[^A-Za-z 0-9]).{8,}$/);
export const namePattern = new RegExp(/^.{2,50}$/);
